import { Heading as HeadingChakra, HeadingProps } from "@chakra-ui/layout";
import { headingSize } from "core/resources/theme/text";

function Heading({ ...props }: HeadingProps) {
  return (
    <HeadingChakra
      fontFamily="Poppins"
      fontWeight="regular"
      fontSize={headingSize}
      {...props}
    />
  );
}

export default Heading;
